import EventTarget from "@ungap/event-target";

interface EventMap {
    "toggle-routes": boolean;
}

export class OptionsStore { 
    private static _instance = new OptionsStore(); 
    private _eventTarget = new EventTarget();
    public static get instance() { return OptionsStore._instance }
    private _showRoutes = true;

    private constructor() { 
        this._showRoutes = localStorage.getItem("show-routes") !== "false";        
    }

    get showRoutes() { 
        return this._showRoutes;
    }

    set showRoutes(value: boolean) { 
        this._showRoutes = value;
        this.emit("toggle-routes", value);
        localStorage.setItem("show-routes", value ? "true" : "false");
    }
   
    addEventListener<K extends Extract<keyof EventMap, string>>(type: K, listener: (this: EventSource, ev: CustomEvent<EventMap[K]>) => any, options?: boolean | AddEventListenerOptions) {
        return this._eventTarget.addEventListener(type, listener, options);
    }
    
    removeEventListener<K extends Extract<keyof EventMap, string>>(type: K, listener: (this: EventSource, ev: CustomEvent<EventMap[K]>) => any, options?: boolean | AddEventListenerOptions) {
        return this._eventTarget.removeEventListener(type, listener, options);
    }
    
    private emit<K extends Extract<keyof EventMap, string>, T extends EventMap>(type: K, value: T[K]) {
        return this._eventTarget.dispatchEvent(new CustomEvent(type, { detail:  value })); 
    }
}
